import { createTextMask } from 'redux-form-input-masks';

const dateMask = createTextMask({
  pattern: '99/99/9999',
  stripMask: false,
});

export default dateMask;
